import getApi from '../../../api/apisauceConfig'

export const deleteTeam = (teamId: string) => getApi().delete<null>(`admin/teams/${teamId}`)
